import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

interface OverallProgressCardProps {
  progressPercent: number;
  error?: string;
}

const OverallProgressCard: React.FC<OverallProgressCardProps> = ({ progressPercent, error }) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-6">
      <CardContent className="p-4 pb-6">
        <div className="mb-2 flex items-center justify-between">
          <span className="revy-cjk text-base leading-[1.75]">
            {t('drbfm.processing.overallProgress')}
          </span>
          <span className="revy-figure text-xl font-medium text-primary">
            {progressPercent}%
          </span>
        </div>
        <Progress value={progressPercent} className="h-2.5 rounded-[5px]" />
        {error && (
          <p className="revy-cjk mt-2 text-sm leading-[1.5] text-destructive">{error}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default OverallProgressCard;
